import Link from "next/link";
import React, { Component } from "react";
import LazyLoad from "react-lazyload";
import { Col, Row, Card } from "react-bootstrap";
import { IKImage } from "imagekitio-react";
import { connect } from "react-redux";
import { brandActions } from "../_actions";
import BackDrop from "./BackDrop";
import styles from "../styles/products.module.css";

class BrandList extends Component {
  constructor(props) {
    super(props);
    const { brandsList } = this.props;
    this.state = {
      error: false,
      brands: brandsList,
      category: false,
      sortBy: "default",
    };
    this.onChangeHandle = this.onChangeHandle.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { brands } = nextProps;
    if (brands) {
      const { category } = brands;
      this.setState({
        brands: brands.brands,
        category: category,
      });
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    return this.state === nextState ? false : true;
  }
  onChangeHandle(e) {
    const sortby = e.target.value;
    this.setState({ sortBy: e.target.value });
    this.props.getBrandList(this.props.catslug, sortby);
  }
  render() {
    const loadingBrand = this.props.loadingBrand;
    const { brands, category, sortBy } = this.state;
    return (
      <>
        {loadingBrand ? (
          <BackDrop />
        ) : (
          <>
            <div className="row mb-4">
              <div className="col-md-8 col-6">
                <h2 className="m-0 fw-600 text-dark">Select Brand</h2>
              </div>
              <div className="col-md-4 col-6">
                <div className="d-flex align-items-center justify-content-end gap-3">
                  <div className="text-nowrap">Sort By:</div>
                  <div>
                    <select className="dropdown-select form-control" id="sort_products" name="sort_products" onChange={this.onChangeHandle} value={sortBy} >
                      <option value="default">Default</option>
                      <option value="name_asc">Sort by name A to Z</option>
                      <option value="name_desc">Sort by name Z to A</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              {brands.map((brand) => {
                return (
                  <div className="col-lg-2 col-md-3 col-4 mb-4" key={brand.id}>
                    <Link href={`/${this.props.catslug}/${brand.slug}`}>
                      <a className="brandcircle text-center">
                        <div className="brandcircleimg rounded-circle shadow-default mb-2 overflow-hidden mx-auto">
                          <LazyLoad offset={100} once>
                            <IKImage
                              urlEndpoint="https://ik.imagekit.io/budli"
                              path={`${brand.image}?tr=h-150,w-150,cm-pad_resize`}
                              alt={brand.name}
                              title={brand.name}
                              loading="lazy"
                              lqip={{ active: true }}
                              width="120"
                            />
                          </LazyLoad>
                        </div>
                        <div className="text-dark fw-500">{brand.name}</div>
                      </a>
                    </Link>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </>
    );
  }
}

const mapState = (state) => ({
  loadingBrand: state.catalog.brands.loadingBrand,
  brands: state.catalog.brands.brandList,
});

const actionCreators = {
  getBrandList: brandActions.getBrandList,
};

export default connect(mapState, actionCreators)(BrandList);
